import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { POSTAPI, errStatusHandler, generateHeader } from "src/api-setup/api-helper";
import {
  GET_ETL_TABLE_DATA,
  GET_COMP_PLAN_PERIOD_DATA,
  GET_JOB_PROCESS_MASTER,
  GET_JOB_HISTORY,
  GET_SELECT_GRID_COLUMN_XML,
  GET_JOB_PERIOD_DATA,
} from "../../api-setup/api-endpoints";
import { formatSystemDate, GridColumnDataMapper, applyDateFormat } from "src/utils/utils";
import { transformDateTime } from "src/lib/date-time.util";
import { getUserCredential } from "../../lib/cookies";
import { setNewMessage } from "src/redux/actions/setting-actions";

export default function AuditLogs() {
  const [columns, setColumns] = React.useState([]);
  const [noDataFound, setNoDataFound] = React.useState(false);
  const [isSearchClick, setSearchClick] = React.useState(false);
  const [initialLoading, setLoadingState] = React.useState(false);
  const [dataCount, setDataCount] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [isAPICalling, setAPICallingState] = React.useState(false);

  const [moduleTypeFields, setModuleTypeFields] = React.useState({
    moduleValue: { id: "", text: "Select Module" },
    moduleData: [],
    isModuleDataLoading: true,
  });
  const [originModuleType, setOriginModuleType] = React.useState([]);

  const [jobdataList, setJobDataList] = React.useState({
    jobValue: { in_job_mstr_key: "" },
    jobData: [],
    isJobDataLoading: true,
  });
  const [originJobData, setOriginJobData] = React.useState([]);

  const [compPlanFields, setcompPlanFields] = React.useState({
    compPlanValue: { in_comp_plan_mstr_key: "" },
    compPlanData: [],
    iscompPlanDataLoading: true,
  });
  const [originCompPlan, setOriginCompPlan] = React.useState([]);

  const [periodMasterData, setPeriodMasterData] = React.useState({
    periodValue: { in_period_mstr_key: "" },
    periodData: [],
    isPeriodDataLoading: true,
  });
  const [originPeriod, setOriginPeriod] = React.useState([]);
  const [positionLoadingState, setPositionLoadingState] = React.useState(false);
  const [positionAPICallingState, setPositionAPICallingState] = React.useState(false);
  const [positionData, setPositionData] = React.useState([]);
  const [positionDataCount, setPositionDataCount] = React.useState(0);

  const cookiesData = getUserCredential();
  const header = { "x-access-token": cookiesData.secretToken };
  const dispatch = useDispatch();
  const history = useHistory();

  // Dropdown fetch
  const getEmailLogDropDownDataAsync = (api, reqBody) => {
    return new Promise((resolve) => {
      POSTAPI(false, api, null, generateHeader(), reqBody, dispatch).then((res) => {
        if (res.status) {
          setLoadingState(true);
          setAPICallingState(false);
          // setNoDataFound(true);
          resolve(res?.data?.row_result || []);
        }
      });
    });
  };

  // Main data fetch
  const getListDataAsync = (api, reqBody) => {
    return new Promise((resolve) => {
      POSTAPI(false, api, null, generateHeader(), reqBody, dispatch).then((res) => {
        if (res.status) {
          setLoadingState(true);
          setSearchClick(false);
          // Handle columns
          if (columns.length === 0) {
            const alwaysHideFields = ["error_code"];
            const userOnlyHideFields = [
              "job_name",
              "comp_plan_name",
              "period_name",
              "linked_positions",
              "linked_positions_name",
            ];
            const columnData = GridColumnDataMapper(res?.data?.out_parameters?.out_columns_xml)
              .filter((cItem) => {
                if (alwaysHideFields.includes(cItem.field)) {
                  return false;
                }

                // Remove user-only fields if module type is User
                if (moduleTypeFields.moduleValue.text === "User" && userOnlyHideFields.includes(cItem.field)) {
                  return false;
                }

                return true;
              })
              .map((cItem) => ({
                ...cItem,
                show:
                  moduleTypeFields.moduleValue.text === "User" && cItem.field === "linked_positions_names"
                    ? false
                    : true,
              }));
            setColumns(columnData);
          }

          const resData = res.data.row_result.map((val) => ({
            ...val,
            action_date: formatSystemDate(val.action_date),
          }));
          setAPICallingState(false);
          setNoDataFound(false);
          setData(resData);
          setDataCount(res.data.out_parameters.out_total_rows);
          resolve(true);
        } else {
          setNoDataFound(true);
          setAPICallingState(false);
        }
      });
    });
  };

  const getExportDataAsync = (api, reqData) => {
    return new Promise((resolve) => {
      POSTAPI(false, api, null, generateHeader(), reqData, dispatch).then((res) => {
        if (res.status && res.data.out_parameters.out_ret_code <= 3) {
          let resData = res.data.row_result;
          let columnData = GridColumnDataMapper(res.data.out_parameters.out_columns_xml).map((cItem) => ({
            ...cItem,
            show: true,
          }));

          columnData.forEach((item) => {
            // if (item.type === "date") {
            //   resData.forEach((rItem) => {
            //     rItem[item.field] =
            //       rItem[item.field] === "0000-00-00 00:00:00"
            //         ? ""
            //         : rItem[item.field] = new Date(
            //                         applyDateFormat(rItem[item.field], item.format)
            //                       );
            //   });
            // }
            if (item.type === "boolean") {
              resData.forEach((rItem) => {
                rItem[item.field] = rItem[item.field] ? "true" : "false";
              });
            }
          });

          resolve(resData);
        } else {
          setNoDataFound(true);
          resolve(false);
        }
      });
    });
  };

  // ETL table fetch
  const getEtlTableData = (listData) => {
    return new Promise((resolve) => {
      POSTAPI(false, GET_ETL_TABLE_DATA, null, header, listData, dispatch).then((res) => {
        if (res.data.row_result.length > 0) {
          const tempArray = res.data.row_result.map((item) => ({
            text: item.etl_table_label,
            id: item.etl_table_mstr_key,
            code: item.etl_table_name,
          }));

          setOriginModuleType(tempArray);
          setModuleTypeFields({
            ...moduleTypeFields,
            moduleData: tempArray,
            moduleValue: tempArray[1],
            isModuleDataLoading: false,
          });

          resolve(tempArray);
        } else {
          setModuleTypeFields({
            ...moduleTypeFields,
            isModuleDataLoading: false,
          });
        }
      });
    });
  };

  // Job Data
  const getJobDataList = (jobprocessApiCallData, type) => {
    const errorCondition = " AND (a.error_code <> 8000)";
    jobprocessApiCallData.in_job_type = type === "report_publish" ? 2 : 1;

    if (!jobprocessApiCallData.in_filter.includes("a.error_code")) {
      jobprocessApiCallData.in_filter += errorCondition;
    }

    setJobDataList({
      jobValue: { in_job_mstr_key: "" },
      jobData: [],
      isJobDataLoading: true,
    });
    setOriginJobData([]);
    return new Promise((resolve) => {
      POSTAPI(false, GET_JOB_PERIOD_DATA, null, header, jobprocessApiCallData, dispatch).then((res) => {
        if (res.data.row_result.length > 0) {
          const jobKeySet = new Set();
          const tempArray = res.data.row_result.reduce((acc, item) => {
            if (!jobKeySet.has(item.job_mstr_key)) {
              jobKeySet.add(item.job_mstr_key);
              acc.push({ text: item.job_name, id: item.job_mstr_key, type: item.job_type_code });
            }
            return acc;
          }, []);

          setOriginJobData(tempArray);
          setJobDataList({
            ...jobdataList,
            jobData: tempArray,
            jobValue: tempArray[0],
            isJobDataLoading: false,
          });

          getCompPlanData(jobprocessApiCallData, tempArray[0]).then(() => resolve(tempArray));
        } else {
          setJobDataList({ ...jobdataList, isJobDataLoading: false });
          resolve([]);
        }
      });
    });
  };

  // Comp Plan Data
  const getCompPlanData = (jobprocessApiCallData, selectedJob) => {
    jobprocessApiCallData.in_filter = `AND a.job_mstr_key = ${selectedJob.id}`;
    jobprocessApiCallData.in_job_type = selectedJob?.type === "report_publish" ? 2 : 1;

    const errorCondition = " AND (a.error_code <> 8000)";

    if (!jobprocessApiCallData.in_filter.includes("a.error_code")) {
      jobprocessApiCallData.in_filter += errorCondition;
    }

    setcompPlanFields({
      ...compPlanFields,
      compPlanValue: { in_comp_plan_mstr_key: "" },
      compPlanData: [],
      iscompPlanDataLoading: true,
    });
    setOriginCompPlan([]);
    return new Promise((resolve) => {
      POSTAPI(false, GET_JOB_PERIOD_DATA, null, header, jobprocessApiCallData, dispatch).then((res) => {
        if (res.data.row_result.length > 0) {
          const compPlanKeySet = new Set();
          const tempArray = res.data.row_result.reduce((acc, item) => {
            if (!compPlanKeySet.has(item.comp_plan_mstr_key)) {
              compPlanKeySet.add(item.comp_plan_mstr_key);
              acc.push({ text: item.comp_plan_name, id: item.comp_plan_mstr_key });
            }
            return acc;
          }, []);
          setOriginCompPlan(tempArray);
          setcompPlanFields({
            ...compPlanFields,
            compPlanData: tempArray,
            compPlanValue: tempArray[0],
            iscompPlanDataLoading: false,
          });

          fetchCompPlanPeriods(jobprocessApiCallData, selectedJob, tempArray[0]);
        } else {
          setcompPlanFields({
            ...compPlanFields,
            iscompPlanDataLoading: false,
          });
          resolve([]);
        }
      });
    });
  };

  // Period Data
  const fetchCompPlanPeriods = (jobprocessApiCallData, selectedJob, compPlan) => {
    jobprocessApiCallData.in_filter = compPlan?.id
      ? `AND a.job_mstr_key = ${selectedJob.id} AND a.comp_plan_mstr_key = ${compPlan.id}`
      : `AND a.job_mstr_key = ${selectedJob.id}`;
    jobprocessApiCallData.in_job_type = selectedJob?.type === "report_publish" ? 2 : 1;
    setPeriodMasterData({
      ...periodMasterData,
      isPeriodDataLoading: true,
      periodValue: { in_period_mstr_key: "" },
      periodData: [],
    });
    setOriginPeriod([]);

    const errorCondition = " AND (a.error_code <> 8000)";

    if (!jobprocessApiCallData.in_filter.includes("a.error_code")) {
      jobprocessApiCallData.in_filter += errorCondition;
    }

    return new Promise((resolve) => {
      POSTAPI(false, GET_JOB_PERIOD_DATA, null, header, jobprocessApiCallData, dispatch).then((res) => {
        if (res.data.row_result.length > 0) {
          const periodKeySet = new Set();
          const tempArray = res.data.row_result.reduce((acc, item) => {
            if (!periodKeySet.has(item.period_mstr_key)) {
              periodKeySet.add(item.period_mstr_key);
              acc.push({ text: item.plan_year, id: item.period_mstr_key });
            }
            return acc;
          }, []);

          setOriginPeriod(tempArray);
          setPeriodMasterData({
            ...periodMasterData,
            periodData: tempArray,
            periodValue: tempArray[0],
            isPeriodDataLoading: false,
          });
          resolve(tempArray);
        } else {
          setPeriodMasterData({
            ...periodMasterData,
            isPeriodDataLoading: false,
          });
          resolve([]);
        }
      });
    });
  };

  const getColumListXMLData = (reqData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_SELECT_GRID_COLUMN_XML, null, header, reqData, dispatch).then((res) => {
        if (res.data && res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          setAPICallingState(true);
          setLoadingState(true);
          errStatusHandler(res, history, dispatch);
        } else {
          const columData = GridColumnDataMapper(res.data.out_parameters.out_columns_xml);

          setColumns(columData);
          resolve(columData);
        }
      });
    }).then((res) => {
      return res;
    });
  };

  const getLinkedPositionsDataAsync = (listData, filterData) => {
    listData.in_filter = listData.in_filter !== null ? filterData + listData.in_filter : filterData;
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_JOB_HISTORY, null, header, listData, dispatch).then((res) => {
        if (res) {
          const reqData = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_filter_db_name: "procare_system",
            in_filter_table_name: "vw_job_history",
            in_result_name_mstr_key: 0,
            in_event_type_mstr_key: 0,
            in_hide_column: 0,
          };

          if (listData.in_load_type == "grid-reload") {
            setTimeout(function () {
              getColumListXMLData(reqData);
            }, 100);
          }
          if (res.data.out_parameters.out_ret_code > 0) {
            setPositionLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }
          let userData = [];
          userData = JSON.parse(JSON.stringify(res.data.row_result));
          userData.forEach((item, idx) => {
            item.rowId = idx;
            item.selected = false;
            // Check each key in POSTION_PARMAS

            return 0;
          });
          setPositionLoadingState(true);

          setPositionData(userData);
          setPositionDataCount(res.data.out_parameters.out_total_rows);
          //   setRefreshLoading(false);

          resolve(userData ,res.data.out_parameters.out_total_rows);
        }
      });
    })
      .then((res ,totalRows) => {
        return res;
      })
      .catch((res ,totalRows) => {
        if (totalRows > 0) {
          setPositionAPICallingState(false);
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  // Return API/data control
  return [
    {
      columns,
      setColumns,
      data,
      setData,
      dataCount,
      initialLoading,
      noDataFound,
      isAPICalling,
      setAPICallingState,
      isSearchClick,
      setSearchClick,
      moduleTypeFields,
      originModuleType,
      setModuleTypeFields,
      originCompPlan,
      compPlanFields,
      setcompPlanFields,
      originPeriod,
      setOriginPeriod,
      periodMasterData,
      setPeriodMasterData,
      jobdataList,
      setJobDataList,
      originJobData,
      positionLoadingState,
      positionAPICallingState,
      positionData,
      positionDataCount,
      setPositionAPICallingState,
    },
    {
      getListDataAsync,
      getExportDataAsync,
      getEmailLogDropDownDataAsync,
      getEtlTableData,
      getCompPlanData,
      fetchCompPlanPeriods,
      getJobDataList,
      getLinkedPositionsDataAsync,
    },
  ];
}
